module.exports = __webpack_public_path__ + "static/2front-design-3-64bf2deeec77d14321c84dd052cff054.png";